import api from "../services/api";

const path = "video";

export const getVideosForDisplay = async () => {
  return await api.get(`${path}/exibicao`);
};

export const getVideos = async () => {
  return await api.get(`${path}`);
};

export const findVideo = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editVideo = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createVideo = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteVideo = async ({ id }) => {
  return await api.delete(`${path}/${id}`);
};
